import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const MainTemplate = styled.div`
  section.box {
    margin-top: 40px;
    position: relative;

    &:first-child {
      margin-top: 0;
    }
  }

  .items-scrollBar.type-prd2line,
  .category-menubar .swiper {
    padding: 0 16px;
  }

  .bg-dark {
    background-color: #1a1a1a;
    padding: 48px 0;

    .prd-skeleton-list {
      .skeleton {
        background-color: rgba(255, 255, 255, 0.1);
      }
    }
  }

  /* .corner-quick-menu {
    margin-top: 12px !important;

    + .box {
      margin-top: 48px;
    }

    .quickmenu-list {
      padding-bottom: 0;
    }
  } */

  .corner-quick-menu-new {
    margin-top: 0 !important;
    overflow: hidden;
    padding-top: 12px;
    padding-bottom: 28px;

    + .box {
      margin-top: 0;
    }
  }

  .corner-styleclip {
    .component-refresh-btn {
      height: calc(49px + ${mixin.pxToVw('342')});
    }

    .area-prd .area-info .prdc-title .detail {
      color: #333;
    }
  }

  .corner-recent-picks {
    padding: 32px 0;
    background-color: #f6f6f6;

    .product-item .area-img .img:after {
      display: none;
    }

    .recent-picks-item {
      .section-title {
        padding: 0 16px 12px 16px;
      }
    }

    .recent-picks-item + .recent-picks-item,
    .prd-skeleton-list + .prd-skeleton-list {
      margin-top: 24px;
    }

    .btn-section-more {
      min-width: 175px;

      .text {
        min-width: unset;
      }
    }

    .list,
    .prd-skeleton-list {
      min-height: calc(54px + ${mixin.pxToVw('138')});
    }

    &.category-picks {
      .recent-picks-item {
        .section-title {
          padding: 0 16px 10px 16px;

          .main-title {
            font-size: 16px;
          }
        }
      }
    }
  }

  .corner-sponsored-banner {
    padding: 0 16px;
  }

  .corner-banner-prd-list {
    .reco-banner-item02 {
      .img,
      .veVideo .xgplayer {
        padding-bottom: 59.476%;
      }

      .veVideo {
        min-height: ${mixin.pxToVw('204')};
      }

      .area-info {
        padding: 20px;
        text-align: left;

        .title {
          font-size: 20px;
        }

        .sub-title {
          margin-top: 2px;
        }
      }
    }

    .prdlist {
      margin-top: 8px;
    }

    .product-item {
      padding: 5px 0;

      .area-info .area-click .prdc-title .detail {
        color: #333;
      }
    }
  }

  /* .corner-today-discovery {
    padding: 48px 0;
  } */

  .corner-reco-brand-prd {
    position: relative;
    padding: 40px 0;
    background-color: #f6f6f6;

    .component-refresh-btn {
      height: 296px;
    }
  }

  .corner-theme {
    // 모바일 테마 virtual 모드
    [data-virtuoso-scroller] {
      [data-testid='virtuoso-item-list'] {
        display: flex;
        flex-direction: column;
        row-gap: 48px;
      }
    }
  }

  .corner-ranking {
    .area-info .area-click .prdc-title .detail {
      color: #333;
    }
  }

  .veVideo {
    .loading-icon {
      display: none !important;
    }

    video {
      pointer-events: none;
    }
  }

  .corner-brand-recommend {
    .type-simple-small .area-info .area-click .prdc-title .detail {
      ${mixin.ellipsis(2)};
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    section.box {
      margin-top: ${mixin.pxToVw('40')};
    }

    .items-scrollBar.type-prd2line,
    .category-menubar .swiper {
      padding: ${mixin.pxToVw('0 16')};
    }

    .bg-dark {
      padding: ${mixin.pxToVw('48 0 64 0')};
    }

    /* .corner-quick-menu {
      margin-top: ${mixin.pxToVw('28')};

      + .box {
        margin-top: ${mixin.pxToVw('48')};
      }
    } */

    .corner-quick-menu-new {
      padding-top: ${mixin.pxToVw('12')};
      padding-bottom: ${mixin.pxToVw('28')};
    }

    .corner-styleclip {
      padding-bottom: ${mixin.pxToVw('48')};

      .component-refresh-btn {
        height: ${mixin.pxToVw('391')};
      }
    }

    .corner-recent-picks {
      padding: ${mixin.pxToVw('32 0')};

      .recent-picks-item {
        .section-title {
          padding: ${mixin.pxToVw('0 16 12 16')};
        }
      }

      .recent-picks-item + .recent-picks-item,
      .prd-skeleton-list + .prd-skeleton-list {
        margin-top: ${mixin.pxToVw('24')};
      }

      .btn-section-more {
        min-width: ${mixin.pxToVw('175')};
      }

      .list,
      .prd-skeleton-list {
        min-height: calc(${mixin.pxToVw('54')} + ${mixin.pxToVw('138')});
      }

      &.category-picks {
        .recent-picks-item {
          .section-title {
            padding: ${mixin.pxToVw('0 16 10 16')};

            .main-title {
              font-size: ${mixin.pxToVw('16')};
            }
          }
        }
      }
    }

    .corner-sponsored-banner {
      padding: ${mixin.pxToVw('0 16')};
    }

    .corner-banner-prd-list {
      .reco-banner-item02 {
        .area-info {
          padding: ${mixin.pxToVw('20')};
          text-align: left;

          .title {
            font-size: ${mixin.pxToVw('20')};
          }

          .sub-title {
            margin-top: ${mixin.pxToVw('2')};
          }
        }
      }

      .prdlist {
        margin-top: ${mixin.pxToVw('8')};
      }

      .product-item {
        padding: ${mixin.pxToVw('5 0')};
      }
    }

    /* .corner-today-discovery {
      padding: ${mixin.pxToVw('48 0')};
    } */

    .corner-theme {
      [data-virtuoso-scroller] {
        [data-testid='virtuoso-item-list'] {
          row-gap: ${mixin.pxToVw('48')};
        }
      }
    }
  }

  @media (min-width: 500px) {
    // MO 스켈레톤 호출시 높이 안 맞는 이슈
    .corner-other-recommend {
      .list,
      .prd-skeleton-list {
        min-height: calc(80px + ${mixin.pxToVw('186')});
        margin-bottom: -10px;
      }
    }
  }

  @media (min-width: 600px) {
    // MO 스켈레톤 호출시 높이 안 맞는 이슈
    .corner-other-recommend {
      .list,
      .prd-skeleton-list {
        min-height: calc(80px + ${mixin.pxToVw('187')});
        margin-bottom: -10px;
      }
    }
  }

  @media (min-width: 700px) {
    // MO 스켈레톤 호출시 높이 안 맞는 이슈
    .corner-other-recommend {
      .list,
      .prd-skeleton-list {
        min-height: calc(80px + ${mixin.pxToVw('190')});
        margin-bottom: -10px;
      }
    }
  }

  @media (min-width: 800px) {
    // MO 스켈레톤 호출시 높이 안 맞는 이슈
    .corner-other-recommend {
      .list,
      .prd-skeleton-list {
        min-height: calc(80px + ${mixin.pxToVw('194')});
        margin-bottom: -10px;
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    section.box {
      max-width: var(--pc-width);
      margin: 0 auto;
      margin-top: 80px;

      &.ly-full {
        max-width: none;
        overflow-x: hidden;

        .section-title {
          max-width: var(--pc-width);
          margin: 0 auto;
        }

        .category-menubar {
          max-width: var(--pc-width);
          margin: -6px auto 0 auto;
        }
      }
    }

    .items-scrollBar.type-prd2line,
    .category-menubar .swiper {
      padding: 0;
    }

    .bg-dark {
      padding: 72px 0;
    }

    /* PC 스켈레톤 없는 prd-list 최소 높이값 */
    .single-row-prd-list,
    .double-row-prd-list {
      min-height: 362.78px;
    }

    .corner-recent-picks {
      padding: 56px 0;

      & > .section-title {
        padding: 0 0 28px;
      }

      .recent-picks-item {
        width: var(--pc-width);
        margin: 0 auto;

        .section-title {
          padding: 0 0 20px;
        }
      }

      .recent-picks-item + .recent-picks-item {
        margin-top: 40px;
      }

      &.category-picks {
        .recent-picks-item {
          .section-title {
            padding: 0 0 16px;

            .main-title {
              font-size: 24px;
            }
          }
        }
      }
    }

    .corner-banner-prd-list {
      .reco-banner-item02 {
        height: 510px;

        .img,
        .veVideo .xgplayer {
          padding-bottom: 82.794%;
        }

        .veVideo {
          min-height: unset;
          height: 510px;
        }

        .area-info {
          padding: 0;
          text-align: left;

          .title {
            font-size: 24px;
          }

          .sub-title {
            font-size: 18px;
            margin-top: 8px;
          }
        }
      }

      .prdlist {
        margin-top: 0;
      }

      .product-item {
        padding: 0;
      }
    }

    /* .corner-quick-menu {
      margin-top: 32px !important;

      .box {
        ${mixin.flex({ align: 'center', justify: 'center' })}
        column-gap: 5px;
      }

      + .box {
        margin-top: 56px;
      }
    } */

    .corner-quick-menu-new {
      padding-top: 16px;
      padding-bottom: 64px;

      .box {
        ${mixin.flex({ align: 'center', justify: 'center' })}
        column-gap: 8px;
      }

      + .box {
        margin-top: 0;
      }
    }

    .corner-styleclip {
      min-height: 809px;

      &:has(.category-menubar) {
        min-height: 861px;
      }

      .component-refresh-btn {
        height: 666px;
      }
    }

    .corner-reco-brand-prd {
      padding: 56px 0;

      .items-swiper {
        width: var(--pc-width);
        margin: 0 auto;
      }
    }

    .corner-brand-recommend {
      .type-simple .area-info .area-click .prdc-title .detail {
        ${mixin.ellipsis(1)};
      }
    }
  }
`;
